import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import Overview from './overview';
import GetStartedPage from './onboarding/';
import landingState from 'constants/landingState';
import { AnyObject } from 'types/Common';
import getPath from 'helpers/path';
import { addPermissions, WithPermissions } from 'decorators/addPermissions';
import Messages from 'constants/rpcTypes';

interface ConnectedProps {
  user: AnyObject;
}

type Props = ConnectedProps & WithPermissions;

const GetStarted: React.VFC<Props> = ({ user, isEnabled }) => {
  switch (user.landingState) {
    case landingState.demoStage:
      return <GetStartedPage />;
    case landingState.default:
      if (isEnabled(Messages.GetStarted_View)) {
        return <Overview />;
      }
      return <Redirect to={getPath('/')} />;
    default:
      return <Redirect to={getPath('/')} />;
  }
};

const mapStateToProps = (state): ConnectedProps => ({
  user: state.user,
});

export default connect(mapStateToProps)(addPermissions(GetStarted));
